export const SERVICE_DASHBOARD_ERROR_INDEXES = ['발생 건수', '조치 건수'];
